export default class SettingsNotificationsController {
    constructor($scope, $http, $q) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.$q = $q;

        this.newsletter = false;
        this.consentPersonalData = false;
        this.notificationEventsWithUserNotification = [];
    }

    $onInit() {
        if (!this.loaded && !this.loading) {
            this.loadNewsletter();
            this.loadConsentPersonalData();
            this.loadNotifications();
        }
    }

    loadNewsletter() {
        const deferred = this.$q.defer();

        this.$http.get((locale === 'en' ? '/en' : '') + '/user/api/newsletter').then(
            (response) => {
                this.newsletter = response.data.data;

                deferred.resolve({
                    newsletter: this.newsletter
                });
            },
            (response) => {
                deferred.reject('An unexpected error occurred!');
            }
        );

        return deferred.promise;
    }

    loadConsentPersonalData() {
        const deferred = this.$q.defer();

        this.$http.get((locale === 'en' ? '/en' : '') + '/user/api/consent-personal-data').then(
            (response) => {
                this.consentPersonalData = response.data.data;

                deferred.resolve({
                    consentPersonalData: this.consentPersonalData
                });
            },
            (response) => {
                deferred.reject('An unexpected error occurred!');
            }
        );

        return deferred.promise;
    }

    loadNotifications() {
        const deferred = this.$q.defer();

        this.$http.get((locale === 'en' ? '/en' : '') + '/user/api/notification-events-with-user-notification').then(
            (response) => {
                this.notificationEventsWithUserNotification = response.data.data;

                deferred.resolve({
                    notificationEventsWithUserNotification: this.notificationEventsWithUserNotification
                });
            },
            (response) => {
                deferred.reject('An unexpected error occurred!');
            }
        );

        return deferred.promise;
    }

    saveNewsletter() {
        const deferred = this.$q.defer();

        this.$http.post((locale === 'en' ? '/en' : '') + '/user/api/newsletter', {data: this.newsletter}).then(
            (response) => {
                this.newsletter = response.data.data;

                deferred.resolve({
                    newsletter: this.newsletter
                });
            },
            (response) => {
                deferred.reject('An unexpected error occurred!');
            }
        );

        return deferred.promise;
    }

    saveConsentPersonalData() {
        const deferred = this.$q.defer();

        this.$http.post((locale === 'en' ? '/en' : '') + '/user/api/consent-personal-data', {data: this.consentPersonalData}).then(
            (response) => {
                this.consentPersonalData = response.data.data;

                deferred.resolve({
                    consentPersonalData: this.consentPersonalData
                });
            },
            (response) => {
                deferred.reject('An unexpected error occurred!');
            }
        );

        return deferred.promise;
    }

    saveNotificationEventsWithUserNotification() {
        const deferred = this.$q.defer();

        this.$http.post((locale === 'en' ? '/en' : '') + '/user/api/notification-events-with-user-notification', {data: this.notificationEventsWithUserNotification}).then(
            (response) => {
                this.notificationEventsWithUserNotification = response.data.data;

                deferred.resolve({
                    notificationEventsWithUserNotification: this.notificationEventsWithUserNotification
                });
            },
            (response) => {
                deferred.reject('An unexpected error occurred!');
            }
        );

        return deferred.promise;
    }
}
